<div class="tournaments-page">
  <ng-container *ngIf="!loading">
    <ng-container *ngIf="tournament; else missing">
      <div class="hero-card">
        <div class="hero-icon"><lucide-icon name="trophy" [size]="28"></lucide-icon></div>
        <div>
          <h1>{{ tournament.name }}</h1>
          <p>{{ tournament.club_name }} · {{ tournament.start_date | date:'fullDate' }} · {{ tournament.start_date | date:'shortTime' }}</p>
        </div>
      </div>

      <div class="detail-grid">
        <div class="detail-tile"><div class="detail-label">Admission</div><div class="detail-value">€{{ tournament.admission_price }}</div></div>
        <div class="detail-tile"><div class="detail-label">Max teams</div><div class="detail-value">{{ tournament.max_teams }}</div></div>
        <div class="detail-tile"><div class="detail-label">Registration closes</div><div class="detail-value">{{ tournament.registration_deadline | date:'mediumDate' }}</div></div>
        <div class="detail-tile"><div class="detail-label">Format</div><div class="detail-value">{{ tournament.team_format === 1 ? 'Pairs' : 'Individuals' }}</div></div>
      </div>

      <div class="prize-card" *ngIf="tournament.prize_description">
        <h3>Prize</h3>
        <p>{{ tournament.prize_description }}</p>
      </div>

      <div class="register-cta" data-testid="register-cta">
        <ng-container *ngIf="registrationOpen; else closed">
          <ng-container *ngIf="canRegister">
            <app-partner-picker
              *ngIf="isPairs"
              (partnerSelected)="onPartnerSelected($event)">
            </app-partner-picker>
            <button
              type="button"
              data-testid="register-btn"
              [disabled]="submitting || (isPairs && !selectedPartner)"
              (click)="register()">
              {{ isPairs ? 'Register pair' : 'Register' }}
            </button>
          </ng-container>

          <button
            type="button"
            *ngIf="canConfirm"
            data-testid="confirm-btn"
            [disabled]="submitting"
            (click)="confirm()">
            Confirm pair invite
          </button>

          <p *ngIf="myRegistration && !isPartner && myRegistration.status === RegStatus.PendingPartner" data-testid="waiting-msg">
            Waiting for your partner to confirm…
          </p>

          <p *ngIf="myRegistration && myRegistration.status === RegStatus.Confirmed" data-testid="registered-msg">
            You're registered ✓
          </p>

          <button
            type="button"
            *ngIf="canWithdraw"
            class="link-btn"
            data-testid="withdraw-btn"
            [disabled]="submitting"
            (click)="withdraw()">
            Withdraw
          </button>
        </ng-container>

        <ng-template #closed>
          <p data-testid="closed-msg">Registration is closed.</p>
        </ng-template>

        <p class="action-error" *ngIf="actionError" data-testid="action-error">{{ actionError }}</p>
      </div>

      <a
        *ngIf="isAdmin"
        class="manage-link"
        data-testid="manage-link"
        [routerLink]="['/admin/tournaments', tournament.id, 'manage']">
        Manage tournament
      </a>

      <section *ngIf="bracket" class="bracket-section" data-testid="detail-bracket">
        <h2>Bracket</h2>
        <app-tournament-bracket [bracket]="bracket" [organizer]="false"></app-tournament-bracket>
      </section>
    </ng-container>

    <ng-template #missing>
      <div class="empty-state">
        <h2>Tournament not found</h2>
        <p>The tournament you're looking for doesn't exist or was removed.</p>
      </div>
    </ng-template>
  </ng-container>
</div>
